import { createBrowserRouter } from 'react-router';
import { Admin } from './components/Admin/Admin';
import { ChangePassword } from './components/Auth/ChangePassword';
import { RequireAdmin, RequireAuth } from './components/Auth/guards';
import { Forgot } from './components/Auth/Forgot';
import { Login } from './components/Auth/Login';
import { ResetPassword } from './components/Auth/ResetPassword';
import { Register } from './components/Auth/Register';
import { ServerUrl } from './components/Auth/ServerUrl';
import { Board } from './components/Board/Board';
import { Lists } from './components/Lists/Lists';
import { Settings } from './components/Settings/Settings';

const guarded = (element: React.ReactNode) => <RequireAuth>{element}</RequireAuth>;

export const router = createBrowserRouter([
  { path: '/server', Component: ServerUrl },
  { path: '/login', Component: Login },
  { path: '/forgot', Component: Forgot },
  { path: '/reset/:token', Component: ResetPassword },
  { path: '/register', Component: Register },
  { path: '/invite/:token', Component: Register },
  { path: '/password', element: guarded(<ChangePassword />) },
  { path: '/', element: guarded(<Board />) },
  { path: '/done', element: guarded(<Lists tab="done" />) },
  { path: '/deleted', element: guarded(<Lists tab="deleted" />) },
  { path: '/review', element: guarded(<Lists tab="review" />) },
  { path: '/resting', element: guarded(<Lists tab="resting" />) },
  { path: '/stats', element: guarded(<Lists tab="stats" />) },
  { path: '/settings', element: guarded(<Settings />) },
  {
    path: '/admin',
    element: guarded(
      <RequireAdmin>
        <Admin />
      </RequireAdmin>,
    ),
  },
  { path: '*', element: guarded(<Board />) },
]);
